export const ROLES = {
    Sale: 'Sale',
    Admin: 'Admin'
}